import axios from "axios";
import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    actions: {
        async getMessages({ rootState }, params) {
            const { authToken } = rootState;
            const { entity, entityId } = params;

            const { data } = await axios.get(api_url, {
                params: {
                    r: "api/chat/get-messages",
                    auth_key: authToken,
                    entity,
                    entity_id: entityId,
                },
            });

            return data;
        },

        async createMessage({ rootState }, params) {
            const token = rootState.authToken;
            const { entity, entityId, parentId, message, files } = params;

            const requestParams = {
                entity,
                entity_id: entityId,
                message,
            };

            if (parentId) requestParams.parent_id = parentId;

            const formData = serialize(requestParams);

            if (files && files.length) {
                files.forEach((file) => formData.append("files[]", file));
            }

            const { data } = await axios.post(addAuthKey(`${api_url}/?r=api/chat/post-message`, token), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return data;
        },

        async editMessage({ rootState }, params) {
            const token = rootState.authToken;
            const { id, message, files, oldFiles } = params;

            const requestParams = {
                message,
                oldFiles,
            };

            const url = addAuthKey(`${api_url}/?r=api/chat/edit-message&id=${id}`, token);

            const formData = serialize(requestParams);

            files.forEach((file) => formData.append("files[]", file));

            const { data } = await axios.put(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return data;
        },

        async removeMessage({ rootState }, id) {
            const token = rootState.authToken;

            const { data } = await axios.delete(addAuthKey(`${api_url}/?r=api/chat/delete-message&id=${id}`, token));

            return data;
        },

        async restoreMessage({ rootState }, id) {
            const token = rootState.authToken;

            const { data } = await axios.patch(
                addAuthKey(`${api_url}/?r=api/chat/undelete-message&id=${id}`, token),
            );

            return data;
        },
    },
};
